import React, { useEffect, useState } from 'react';
import { Select360 } from '../kit/Select360';
import axios from 'axios';
import { getApiUrl } from '../../utils/api';

let cache = null;
export const usePostesCatalog = () => {
  const [cat, setCat] = useState(cache);
  useEffect(() => { if (cache) return; axios.get(`${getApiUrl()}/postes/catalog`, { withCredentials: true }).then(r => { cache = r.data; setCat(r.data); }).catch(() => {}); }, []);
  return cat;
};

export const avatarSrc = key => `/personas/${key || 'equipe'}.webp`;

export const PosteSelect = ({ value, roleValue, onChange, legacy }) => {
  const cat = usePostesCatalog();
  if (!cat) return <Select360 className="w-full px-4 py-3 bg-[var(--remplissage)] rounded-xl" disabled><option>Chargement des postes…</option></Select360>;
  const current = cat.postes.find(p => p.poste_id === value);
  return <Select360 value={value || `legacy:${roleValue}`} data-testid="employee-poste-select" className="w-full px-4 py-3 bg-[var(--remplissage)] rounded-xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
    onChange={e => { const v = e.target.value; if (v.startsWith('legacy:')) { onChange(null, v.slice(7), null); return; } const p = cat.postes.find(x => x.poste_id === v); onChange(p.poste_id, p.role_profile, p.persona); }}>
    {!current && <option value={`legacy:${roleValue}`}>{legacy.find(l => l.value === roleValue)?.label || roleValue} (ancien référentiel)</option>}
    {cat.categories.map(c => <optgroup key={c.id} label={c.label}>{cat.postes.filter(p => p.category === c.id).map(p => <option key={p.poste_id} value={p.poste_id}>{p.label}</option>)}</optgroup>)}
  </Select360>;
};

export const AvatarPicker = ({ value, suggested, onChange }) => {
  const cat = usePostesCatalog();
  const list = cat?.personas || [];
  return <div data-testid="employee-avatar-picker">
    <div className="flex items-center gap-3 mb-2">
      <img src={avatarSrc(value || suggested)} alt="" className="w-14 h-14 rounded-2xl object-cover ring-2 ring-emerald-200" data-testid="employee-avatar-preview" />
      <div className="text-sm text-[var(--texte-2)]">Bitmoji de l’équipier·ère.{value && value !== suggested && <button type="button" className="ml-2 text-[var(--p-1f5a30)] font-semibold" data-testid="employee-avatar-reset" onClick={() => onChange(null)}>Revenir à celui du poste</button>}</div>
    </div>
    <div className="grid grid-cols-6 sm:grid-cols-9 gap-2">{list.map(p => <button type="button" key={p.id} title={p.name} aria-label={`Avatar ${p.name}`} aria-pressed={(value || suggested) === p.id} data-testid={`employee-avatar-${p.id}`} onClick={() => onChange(p.id)}
      className={`rounded-xl overflow-hidden ring-2 transition-transform hover:scale-105 ${(value || suggested) === p.id ? 'ring-emerald-500' : 'ring-transparent'}`}><img src={avatarSrc(p.id)} alt="" className="w-full aspect-square object-cover" /></button>)}</div>
  </div>;
};
